import { Longhand } from "../longhand.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/pointer-events}
 * @internal
 */
export default Longhand.fromKeywords({ inherits: true }, "auto", "none");
//# sourceMappingURL=pointer-events.js.map